import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { OeAppService } from './oe-app.service';
import { Store } from './store';
import ConfigurationsDto, { NotificationProvider } from './types/ConfigurationsDto';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProfileServiceConfigurationService extends Store<ConfigurationsDto> {
  constructor(http: HttpClient, oeApp: OeAppService) {
    super();
    http.get<ConfigurationsDto>(`${oeApp.getCommonData().oeProfileServiceHost}/configurations`).subscribe((config) => {
      this.setState(config);
    });
  }

  isSpeechaceCarouselEnabled$() {
    return this.state$.pipe(map((config) => config && config.speechaceCarouselEnabled));
  }

  isPCRevampEnabled$() {
    return this.state$.pipe(map((config) => config && config.pcRevampDesktopUIEnabled));
  }

  coachMobileUIEnabled$() {
    return this.state$.pipe(map((config) => config && config.coachMobileUIEnabled));
  }

  isExtoleEnabled$() {
    return this.state$.pipe(map((config) => config && config.isExtoleEnabled));
  }

  isLiveClassOnboardingEnabled$() {
    return this.state$.pipe(map((config) => config && config.liveClassOnboardingEnabled));
  }

  isPlatformTourGCEnabled$() {
    return this.state$.pipe(map((config) => config && config.isPlatformTourGCEnabled));
  }

  liveClassPromoTileEnabled$() {
    return this.state$.pipe(map((config) => config && config.liveClassPromoTileEnabled));
  }

  yearInReviewEnabled$() {
    return this.state$.pipe(map((config) => config && config.yearInReviewEnabled));
  }

  notificationPushConfig$(): Observable<{
    notificationWebPushProvider: NotificationProvider;
    oneSignalAppId: string;
  }> {
    return this.state$.pipe(
      map(
        (config) =>
          config && {
            notificationWebPushProvider: config.notificationWebPushProvider,
            oneSignalAppId: config.oneSignalAppId,
          }
      )
    );
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/profile-service-configuration.service.ts